import { render, staticRenderFns } from "./ElevatorVideo.vue?vue&type=template&id=270e4db4&scoped=true&"
import script from "./ElevatorVideo.vue?vue&type=script&lang=js&"
export * from "./ElevatorVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270e4db4",
  null
  
)

export default component.exports